import CurriculumEditPage from "./CurriculumEditPage";

export default CurriculumEditPage;